import { useState } from 'react'
import reset from '../assets/arrow-left.svg'
import { clearLocalData } from '../services/storage'
import { useTranslation } from 'react-i18next'
import { useAppContext } from '../contexts/AppContext'
import ConfirmDialog from './ConfirmDialog'

const Footer = () => {
  const { t } = useTranslation()
  const { playbookId } = useAppContext()
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const handleResetClick = () => {
    setShowConfirmDialog(true)
  }

  const handleConfirmReset = async () => {
    setShowConfirmDialog(false)
    await clearLocalData(playbookId)
    window.location.href = window.location.href
  }

  const handleCancelReset = () => {
    setShowConfirmDialog(false)
  }

  return (
    <>
      <div className="bg-wp-bg-gray dark:bg-zinc-800 flex justify-between items-center px-4 h-7 text-sm text-gray-500 dark:text-zinc-400 font-light">
        <button className="flex items-center gap-1" onClick={handleResetClick}>
          <img className="w-3 h-3" src={reset} />
          {t('footer.reset', 'Reset')}
        </button>
        <a href="https://linkando.com/webplays" target="_blank" className="hidden">
          {t('footer.powered_by', 'About WebPlays')}
        </a>
      </div>
      {showConfirmDialog && (
        <ConfirmDialog
          title={t('footer.reset_confirm_title', 'Reset Progress')}
          message={t(
            'footer.reset_confirm_message',
            'Are you sure you want to reset your progress? All your data will be cleared.',
          )}
          onConfirm={handleConfirmReset}
          onCancel={handleCancelReset}
          confirmText={t('footer.reset_confirm_button', 'Reset')}
          cancelText={t('footer.reset_cancel_button', 'Cancel')}
        />
      )}
    </>
  )
}

export default Footer
